var map = {
	"./as-header-logo.svg": "rh+N",
	"./bms-header-logo.svg": "x6eE",
	"./ds-header-logo.svg": "LyTE",
	"./ls-header-logo.svg": "xCSA",
	"./portal-header-logo.svg": "zW7n",
	"./sns-header-logo.svg": "f69z",
	"./tbq-header-logo.svg": "u9tE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uL+J";


//////////////////
// WEBPACK FOOTER
// ./node_modules/pro4all-ui/ui-kit/img ^\.\/.*\-header\-logo\.svg$
// module id = uL+J
// module chunks = 1